import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

export const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms))

export function normalRandomFast(mean = 0, stdDev = 1) {
    let sum = 0
    for (let i = 0; i < 12; i++) {
        sum += Math.random()
    }
    // sum ~ N(6, 1)
    return (sum - 6) * stdDev + mean
}

export function randomRow<T>(arr: T[], count: number) {
    if (count >= arr.length) return arr.slice()
    else {
        const result: T[] = []
        while (result.length < count) {
            const randomIndex = Math.floor(Math.random() * arr.length)
            if (!result.includes(arr[randomIndex]))
                result.push(arr[randomIndex])
        }
        return result
    }
}

dayjs.extend(utc)

export function getStartOfDay() {
    const now = dayjs().unix()
    let todayStart = dayjs
        .unix(now)
        .utcOffset(-7)
        .hour(4)
        .minute(0)
        .second(0)
        .unix()
    if (todayStart > now) {
        todayStart = dayjs.unix(todayStart).subtract(1, "day").unix()
    }
    return todayStart
}
